export const EXPORT_PATH_SUFFIX = '/export';

export const SESSIONS_API = '/api/sessions';

export const GEOJSON_POINT_TYPE = 'Point';

export const GEOJSON_LINE_STRING_TYPE = 'LineString';

export const ROUTE_PATTERN_EDGE_SWEEP = 'EDGE_SWEEP';

export const ROUTE_PATTERN_EDGE_SWEEP_ONLY = 'EDGE_SWEEP_ONLY';

export const ROUTE_PATTERN_NO_EDGE_SWEEP = 'NO_EDGE_SWEEP';

export const COVERAGE_AREA_BOUNDARY_ONLY = 'BOUNDARY_ONLY';

export const COVERAGE_AREA_ROUTE_AND_BOUNDARY = 'ROUTE_AND_BOUNDARY';

export const EXPORT_FAILED = 'Failed to export flight plan';

export const CONNECTION_ERROR = 'Connection error — please try again';
